const File = [
  { type: 'item', text: 'Close' },
];

const View = [
  { type: 'item', disable: true, text: 'Sort by: Urgency' },
];

const Help = [
  { type: 'item', disable: true, text: 'About Outlook Express' },
];

export default { File, View, Help };
